import { createAction } from "@reduxjs/toolkit";
import axios from 'apis';
import { asyncThunkWrapper } from "helpers/asyncThunkWrapper";

const attributes = [
  'id', 
  'input', 
  {esign_template: ['id', { template: [ 'id', 'name'] }]}, 
  'status', 
  'updated_at'
];
const fullAttributes = [
  'id',
  'input', 
  { result: ['id', 'filename', 'content_type', 'url'] }, 
  {esign_template: ['id', { template: [ 'id', 'name'] }]},
  'status', 
  'updated_at'
];

export const getEsignAnalyses = asyncThunkWrapper({ 
  model: 'esignAnalyses', 
  action: 'getEsignAnalyses', 
  func: async ({ offset = 0 }) => {
    const params = { limit: 25, offset, orders: { updated_at: 'desc' }, attributes };
    const response = await axios.get('/esign_flow/esign_analyses', { params });

    return response.data;
  } 
});
export const getEsignAnalysis = asyncThunkWrapper({ 
  model: 'esignAnalyses', 
  action: 'getEsignAnalysis', 
  func: async ({ id, cable = false }) => {
    const params = { attributes: fullAttributes };
    const response = await axios.get(`/esign_analyses/${id}`, { params });

    return { data: response.data, cable }
  } 
});
export const clearLocalEsignAnalyses = createAction('esignAnalyses/clearLocalEsignAnalyses');
export const clearLocalActiveEsignAnalysis = createAction('esignAnalyses/clearLocalActiveEsignAnalysis');